import {
  ValidatedSetLens3tjmcbmmtgp0c as ValidatedSetLens,
  ValidatedModifyLensxnr6y4izl6zn as ValidatedModifyLens,
  ValidatedSetValueLens1a0iz59dg9w6t as ValidatedSetValueLens,
  ValidatedModifyValueLensyxkqbmnu4076 as ValidatedModifyValueLens,
} from './validationLenses.mjs';
import {
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
  ReactiveValue37mnzha3zo6xb as ReactiveValue,
} from '../../core/coreInterfaces.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lens(get, set) {
  return ValidatedSetLens().new_com_lightningkite_reactive_lensing_validation_ValidatedSetLens_tc311d_k$(this, get, set);
}
function lens_0(get, modify) {
  return ValidatedModifyLens().new_com_lightningkite_reactive_lensing_validation_ValidatedModifyLens_n91gng_k$(this, get, modify);
}
var MutableValidatedClass;
function MutableValidated() {
  if (MutableValidatedClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableValidated', VOID, VOID, [MutableReactive(), Reactive()], [1]);
    MutableValidatedClass = $;
  }
  return MutableValidatedClass;
}
function get_issues(_this__u8e3s4) {
  return _this__u8e3s4.get_node_wor8sr_k$().issues_1;
}
function lens_1(get, set) {
  return ValidatedSetValueLens().new_com_lightningkite_reactive_lensing_validation_ValidatedSetValueLens_stsrt7_k$(this, get, set);
}
function lens_2(get, modify) {
  return ValidatedModifyValueLens().new_com_lightningkite_reactive_lensing_validation_ValidatedModifyValueLens_g7yxco_k$(this, get, modify);
}
var MutableValidatedValueClass;
function MutableValidatedValue() {
  if (MutableValidatedValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableValidatedValue', VOID, VOID, [MutableReactiveValue(), ReactiveValue(), Reactive(), MutableValidated()], [1]);
    MutableValidatedValueClass = $;
  }
  return MutableValidatedValueClass;
}
//region block: exports
export {
  lens_0 as lens2dr2mfn274h1a,
  lens as lensi9s8q1zaykbw,
  lens_2 as lens2wuprihu5z787,
  lens_1 as lens2gvfhjoqnpofs,
  MutableValidatedValue as MutableValidatedValuegls7jkstsdwb,
  MutableValidated as MutableValidated2ognu5vxf17ur,
  get_issues as get_issues1z1skb5sgeygq,
};
//endregion

//# sourceMappingURL=Validated.mjs.map
